export const SUPPORT_EMAIL = "support@scrapchef.ai";

// Dependency-free copy for error rendering when translations fail.
export const FALLBACK_TEXT: Record<string, string> = {
  globalErrorTitle: "Something went wrong",
  globalErrorDescription:
    "An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.",
  globalErrorRefresh: "Refresh Page",
  globalErrorContactSupport: "Contact Support",
  signOut: "Sign out",
};

/** Normalises thrown strings and objects to Error instances. */
export const normalizeError = (error: unknown): Error | undefined => {
  if (!error) return undefined;
  if (error instanceof Error) return error;
  if (typeof error === "string") return new Error(error);
  if (typeof error === "object") {
    const msg =
      "message" in error && typeof error.message === "string"
        ? error.message
        : JSON.stringify(error);
    return new Error(msg);
  }
  return new Error(JSON.stringify(error));
};

export const clearBrowserCache = (): void => {
  try {
    // Clear localStorage except Firebase auth keys
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !key.startsWith("firebase:")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });

    if ("caches" in window) {
      caches
        .keys()
        .then((names) => {
          names.forEach((name) => void caches.delete(name));
        })
        .catch(() => {
          // Error recovery does not depend on cache cleanup succeeding.
        });
    }
  } catch {
    // Error recovery does not depend on browser storage being available.
  }
};

export const refreshPage = (): void => {
  clearBrowserCache();
  window.location.reload();
};

export const logoutAndRedirect = async (): Promise<void> => {
  try {
    const { getAuth, signOut } = await import("firebase/auth");
    const auth = getAuth();
    await signOut(auth);
  } catch {
    // Redirect even when the authentication service is unavailable.
  }
  clearBrowserCache();
  window.location.href = "/sign-in";
};
